<template>
    <div>
        <v-app id="basic-layout">
            <child />
        </v-app>
        <Footer></Footer>
    </div>
</template>
<style scoped lang="scss">
    #basic-layout {
        background-color: #F3F5F8;
    }
</style>
<script>
    import store from '@/store/index';
    import Footer from '@/components/Footer';

    export default {
        name: 'BasicLayout',
        components: {
            Footer
        }
    }
</script>